import { useQuery } from '@tanstack/react-query';
import { IMessage } from '~/models/Message';
import { messageKeys } from '../messageKeys';
import { messagesService } from '../messagesService';

export function useJobMessages(jobId?: string) {
  return useQuery<IMessage[]>({
    queryKey: messageKeys.jobMessages(jobId ?? ''),
    queryFn: () => messagesService.getJobMessages(jobId!),
    enabled: Boolean(jobId),
    staleTime: 1000 * 15,
    refetchOnWindowFocus: false,
  });
}
